import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import BetaWaitlist from '../../Beta-Waitlist/BetaWaitlist';
import '../../SupportSection/Support.css';

const ScrollingAnounce = () => {


  const marqueeContainerRef = useRef(null);
  const marqueeContentRef = useRef(null);


  const [showWaitlist, setShowWaitlist] = useState(false);

  useEffect(() => {
    const marqueeContainer = marqueeContainerRef.current;
    const marqueeContent = marqueeContentRef.current;

    // Clone the marquee content to ensure continuous scrolling
    const marqueeClone = marqueeContent.cloneNode(true);
    marqueeContainer.appendChild(marqueeClone);

    let containerWidth = marqueeContainer.offsetWidth;
    let contentWidth = marqueeContent.offsetWidth;

    // Starting position of the marquee
    let position = containerWidth;

    const animate = () => {
      position -= 1.7; // Speed of scrolling (increase or decrease this value for faster/slower speed)

      // Move the marquee content by adjusting its left position
      marqueeContent.style.transform = `translateX(${position}px)`;

      // Reset position when the content has fully moved out of view
      if (position <= -contentWidth) {
        position = containerWidth;
      }

      requestAnimationFrame(animate);
    };

    animate(); // Start the animation
  }, []);

  return (
<section className="start-for-free">
<BetaWaitlist
        showJoinWaitList={showWaitlist}
        onClose={() => setShowWaitlist(false)}
        onOpen={() => setShowWaitlist(true)}
        //flag={priority-waitlist}
        />
  <div className="row">
    <div className="col-md-12 main-heading-text1 text-center">
      <div
        ref={marqueeContainerRef}
        style={{
          width: '100%',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }}
      >
        <div ref={marqueeContentRef} style={{ display: 'inline-block' }} className='scrolling-text-sec'>
          <span className='marquess'>
              It’s time to get rentid. Start for free. Earn more than ever before. Take control of your business. 
          </span>

          <span className='marquess'>
              It’s time to get rentid. Start for free. Earn more than ever before. Take control of your business. 
          </span>

          <span className='marquess'>
              It’s time to get rentid. Start for free. Earn more than ever before. Take control of your business. 
          </span>

          <span className='marquess'>
              It’s time to get rentid. Start for free. Earn more than ever before. Take control of your business. 
          </span>

          <span className='marquess'>
              It’s time to get rentid. Start for free. Earn more than ever before. Take control of your business. 
          </span>

          <span className='marquess'>
              It’s time to get rentid. Start for free. Earn more than ever before. Take control of your business. 
          </span>

          <span className='marquess'>
              It’s time to get rentid. Start for free. Earn more than ever before. Take control of your business. 
          </span>

          <span className='marquess'>
              It’s time to get rentid. Start for free. Earn more than ever before. Take control of your business. 
          </span>

          <span className='marquess'>
              It’s time to get rentid. Start for free. Earn more than ever before. Take control of your business. 
          </span>

          <span className='marquess'>
              It’s time to get rentid. Start for free. Earn more than ever before. Take control of your business. 
          </span>

          <span className='marquess'>
              It’s time to get rentid. Start for free. Earn more than ever before. Take control of your business. 
          </span>

          <span className='marquess'>
              It’s time to get rentid. Start for free. Earn more than ever before. Take control of your business. 
          </span>

          <span className='marquess'>
              It’s time to get rentid. Start for free. Earn more than ever before. Take control of your business. 
          </span>

          <span className='marquess'>
              It’s time to get rentid. Start for free. Earn more than ever before. Take control of your business. 
          </span>

          <span className='marquess'>
              It’s time to get rentid. Start for free. Earn more than ever before. Take control of your business. 
          </span>
        
        </div>
      </div>
      <p>Join our <span>beta test group</span> - there’s only upside from here. </p>
      {/* <p className="free-text">
        <img src="/img/time.svg" alt="" className="img-fluid"/>Takes less than 10 minutes
      </p> */}
    </div>
    <div className="beta-user">
      {/* <button className="btn-getstarted1 d-lg-block1 openModal" data-bs-toggle="modal" data-bs-target="#exampleModal">Become a Beta User</button> */}
      <Link to="https://app.rentid.io/sign-up" className="btn-getstarted1 d-lg-block1">Get Started</Link>
    </div>
  </div>
</section>


 
  );
};

export default ScrollingAnounce;